var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeIsReferralOutline = function SvgCassiopeiaBadgeIsReferralOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.453,
    height: 49.763,
    viewBox: "0 0 5.412 13.166",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.46-13.382a1.725 1.725 0 0 0-.88 3.207v4.035a1.725 1.725 0 0 0 0 2.965V-.25c-.402.24-.69.632-.797 1.088C4.058 1.965.545 6.213.545 11.285c0 .84.106 1.655.289 2.44 1.491 9.267 11.793 19.044 19.178 21.728l.084-.035-4.885-8.143a1.633 1.633 0 0 1 .039-1.74l4.783-7.234-6.525-5.594a1.633 1.633 0 0 1-.338-2.08l4.685-7.809a10.644 10.644 0 0 0-5.798-2.24 1.725 1.725 0 0 0-.715-.828v-2.925a1.725 1.725 0 0 0 0-2.965v-4.035a1.725 1.725 0 0 0-.881-3.207z",
    style: {
      fill: "#fff",
      fillOpacity: 0.501961,
      stroke: "#000",
      strokeWidth: 1.00157,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "3.00471,1.00157",
      strokeDashoffset: 0.701099,
      strokeOpacity: 0.501961
    },
    transform: "matrix(.26458 0 0 .26458 -.012 3.673)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeIsReferralOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-is-referral-outline.c58a0a9c37b295e81ae1de815d743192.svg";